import axiosInstance from '../../../api/axios.js';

/**
 * @param {{ fileData: object[], auditYearId?: string }} args
 */
export async function importGenericRcmMappedRows(args) {
  const body = {
    file_data: Array.isArray(args?.fileData) ? args.fileData : [],
  };
  if (args?.auditYearId) {
    body.audit_year_id = args.auditYearId;
  }
  const { data } = await axiosInstance.post('/api/rcm-upload/import', body);
  return data;
}
